var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXrp01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#23292F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000061458325050698694250000000167805142782120366_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000132085364048782009010000002146739462500377997_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.6,59.5h66.5l-138.4,137c-50.1,49.6-131.3,49.6-181.5,0L20.8,59.5h66.5l105.1,104.1 c31.9,31.4,83.1,31.4,114.9,0L412.6,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.5,440.5H20l139.3-137.8c50.1-49.6,131.3-49.6,181.5,0L480,440.5h-66.5l-106-104.9 c-31.9-31.4-83.1-31.4-114.9,0L86.5,440.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXrp01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/XRP-01.a91bef1f037433a2508140fa5c76eb9e.svg";